export enum ConstraintInstanceType {
  Proposal = 'proposal',
  Sleeve = 'sleeve',
}

export type DiversificationBounds =
  | { kind: 'market_value'; min?: number; max?: number }
  | { kind: 'instruments'; min?: number; max?: number }
  | { kind: 'weight'; min?: number; max?: number }

export type AllocationBounds =
  | { kind: 'market_value'; min?: number; max?: number; target?: number }
  | { kind: 'weight'; min?: number; max?: number; target?: number }
